<template>
  <v-app id="keep">
    <v-app-bar app clipped-left color="primary darken-1" height="64px">
      <v-app-bar-nav-icon
        v-if="$router.history.current.name !== 'Home'"
        @click="drawer = !drawer"
        dark
      ></v-app-bar-nav-icon>
      <span class="title ml-3 mr-5 white--text">
        Easy
        <span class="font-weight-light white--text">App</span>
      </span>
      <v-spacer></v-spacer>
      <span
        v-if="$store.state.loginData.nome !== ''"
        class="title ml-3 mr-5 font-weight-light ellipsis-truncate hidden-xs-only"
        style="color: white !important"
        >{{ $store.state.loginData.nome }}</span
      >
      <v-icon dark v-if="$store.state.loginData.nome !== ''" @click="logout"
        >exit_to_app</v-icon
      >
    </v-app-bar>

    <v-navigation-drawer
      v-if="$router.history.current.name !== 'Home'"
      v-model="drawer"
      app
      clipped
      color="grey lighten-4"
    >
      <v-list dense class="grey lighten-4 pt-3" rounded>
        <template v-for="(item, i) in items">
          <v-list-item
            :key="i"
            link
            @click="$router.push(item.path, () => {})"
            rounded
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.subTitle }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-content class="grey lighten-4">
      <v-container fluid class="mr-0 ml-0">
        <router-view></router-view>
      </v-container>
    </v-content>
    <show-message :open="$store.state.showMessage.open" />
  </v-app>
</template>

<script>
import api from "../api/index.js";
import mask from "br-masks";
import ShowMessage from "./dialogs/ShowMessage.vue";

export default {
  components: { ShowMessage },
  props: {
    source: String
  },
  data: function() {
    return {
      drawer: null,
      items: [
        {
          icon: "description",
          title: "Pedidos",
          subTitle: "Gerencie seus pedidos",
          path: "/pedidos"
        },
        {
          icon: "supervisor_account",
          title: "Clientes",
          subTitle: "Gerencie seus clientes",
          path: "/clientes"
        },
        {
          icon: "store",
          title: "Produtos",
          subTitle: "Catálogo de produtos",
          path: "/produtos"
        }
      ]
    };
  },
  created: function() {
    this.login();
  },
  methods: {
    logout() {
      localStorage.removeItem("senha");
      this.$store.commit("setLoginData", {
        id: null,
        cnpj: "",
        senha: "",
        nome: ""
      });
      this.$router.push("/login", () => {}); // eslint-disable-line
    },
    login() {
      const senha = localStorage.getItem("senha");
      const cnpj = localStorage.getItem("cnpj");
      if (cnpj && cnpj) {
        api.login(
          cnpj,
          senha,
          data => {
            localStorage.setItem("nome", data.nome);
            localStorage.setItem("senha", senha);
            localStorage.setItem("cnpj", data.id);
            this.$store.commit("setLoginData", {
              id: data.id,
              cnpj: mask.cnpj(cnpj.replace(/\D+/g, "")),
              senha: senha,
              nome: data.nome
            });
            this.$router.push("/", () => {}); // eslint-disable-line
          },
          error => {
            if (error.response && error.statusCode === 401) {
              localStorage.removeItem("senha");
            }
            this.senha = "";
            this.$router.push("/login", () => {}); // eslint-disable-line
          }
        );
      } else {
        if (this.$router.currentRoute.name !== "Login") {
          localStorage.removeItem("senha");
          this.$router.push("/login", () => {}); // eslint-disable-line
        }
      }
    }
  }
};
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none;
}
.ellipsis-truncate {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
